import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import Container from "react-bootstrap/Container"
import {RootState} from '../store/store'
import InvoiceForm from '../components/InvoiceForm'
import { useTranslation } from 'react-i18next';
import { Invoice } from "../types/invoiceForm";
import { useLocation } from 'react-router-dom';
import { Offer } from "../types/offerForm"
import OfferForm from "../components/OfferForm"


const EditDocumentPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [form, setForm] = useState<Invoice | Offer>();
  const location = useLocation();
  const { type } = location.state || {};
  const invoices = useSelector((state: RootState) => state.invoices as Invoice[])
  const offers = useSelector((state: RootState) => state.offers as Offer[])
  
  useEffect(() => {
    if(id){
      if(type === 'invoice'){        
        const targetInvoice = invoices.find((invoice: Invoice) => invoice?.id === parseInt(id));
        if (targetInvoice)setForm(targetInvoice)        
      }
      if(type === 'offer'){
        const targetOffer = offers.find((offer: Offer) => offer?.id === parseInt(id));
        if(targetOffer)setForm(targetOffer)        
      }
        
    }    
  }, [invoices, offers, id, type])

  return (
    <div className='d-flex flex-column align-items-center justify-content-center w-100'>
      <Container>
      <h1>{type === 'invoice' ? t('editInvoice') : t('editOffer')}</h1>

        {form ?            
          type === 'invoice' ?
          
           (<InvoiceForm invoice={form as Invoice} isEdit={true}/>) : (<OfferForm offer={form as Offer} isEdit={true}/>)
          :
          <div>No document with id: {id}</div>
        }
      </Container>
    </div>
  )
}

export default EditDocumentPage
